<template lang="pug">
  .box-search
    span.label 設定{{ index + 1}}
    span.updated 更新日 : {{ condition.updatedAt }}
    h4 {{ condition.name }}
    ul
      li
        span 集計内容
        | {{ condition.aggType | normalize }}
      li
        span 集計縦軸
        | {{ condition.verticalAxis | normalize }}
      li
        span 集計期間
        | {{ condition.condition.aggregationFromDate | normalize }} ～
        | {{ condition.condition.aggregationToDate | normalize }}
      li
        span 集計単位
        | {{ condition.rangeType | normalize }}
      li
        span 給与
        | {{ condition.salaryTypes | normalize }}
      li
        span 掲載メディア
        | {{ condition.media | normalize }}
      li
        span 所在地
        | {{ condition.prefectures | normalize }}
        br
        | {{ condition.cities | normalize }}
      li
        span 勤務地
        | {{ condition.workPlacePrefectures | normalize }}
        br
        | {{ condition.workPlaceCities | normalize }}
      li
        span 職種
        | {{ condition.jobtypes | normalize }}
      li
        span 業種
        | {{ condition.industries | normalize }}
      li
        span 雇用形態
        | {{ condition.employments | normalize }}
      li
        span キーワードその他
        | {{ condition.condition.keyword | normalize }}
      li
        span 除外キーワード
        | {{ condition.condition.excludeKeyword | normalize }}
    p.buttons
      input.button-main(type="button", value="検索", @click.prevent="search")
    .box-mylist-delete
      a(@click.prevent="destroy") 削除する
</template>

<script>
  import { mapGetters } from 'vuex'
  import { HumanInfoMessages } from '../../constants'

  const splitter = '、'
  const placeHolder = '-'

  export default {
    props: ['condition', 'index'],
    computed: {
      ...mapGetters('aggJobSearchCondition', ['builtQuery']),
      id () {
        return this.condition.id
      },
    },
    methods: {
      search () {
        const query = this.condition.condition
        const apiQuery = {
                            aggregationFromDate: query.aggregationFromDate,
                            aggregationToDate: query.aggregationToDate,
                            salaryCd: query.salaryCd,
                            rangeType: query.rangeType,
                            aggType: query.aggType,
                            verticalAxis: query.verticalAxis,
                            prefectureCd: query.prefectureCd.map(p => (p.value || p)).join(','),
                            cityCd: query.cityCd.map(p => (p.value || p)).join(','),
                            employmentCd: query.employmentCd.map(ec => (ec.value || ec)).join(','),
                            jobtypeCd: query.jobtypeCd.map(t => (t.value || t)).join(','),
                            industryCd: query.industryCd.map(i => (i.value || i)).join(','),
                            workPlacePrefectureCd: query.workPlacePrefectureCd === undefined ? '' : query.workPlacePrefectureCd.map(p => (p.value || p)).join(','),
                            workPlaceCityCd: query.workPlaceCityCd === undefined ? '' : query.workPlaceCityCd.map(p => (p.value || p)).join(','),
                            mediaCd: query.mediaCd.map(m => (m.value || m)).join(','),
                            keyword: query.keyword === undefined || query.keyword === '' ? '' : query.keyword.map(i => (i.value || i)).join(','),
                            excludeKeyword: query.excludeKeyword === undefined ? '' : query.excludeKeyword.map(i => (i.value || i)).join(','),
                            applyKeywordsToCatchcopy: query.applyKeywordsToCatchcopy,
                            applyKeywordsToJobtypeName: query.applyKeywordsToJobtypeName,
                            applyKeywordsToJobContents: query.applyKeywordsToJobContents,
                            applyKeywordsToQualification: query.applyKeywordsToQualification,
                            applyKeywordsToCompanyName: query.applyKeywordsToCompanyName,
                            applyExcludeKeywordsToCatchcopy: query.applyExcludeKeywordsToCatchcopy,
                            applyExcludeKeywordsToJobtypeName: query.applyExcludeKeywordsToJobtypeName,
                            applyExcludeKeywordsToJobContents: query.applyExcludeKeywordsToJobContents,
                            applyExcludeKeywordsToQualification: query.applyExcludeKeywordsToQualification,
                            applyExcludeKeywordsToCompanyName: query.applyExcludeKeywordsToCompanyName,
                      }
        this.$router.push({
          name: 'AggregateJob',
          query: apiQuery,
        })
      },
      async destroy () {
        // eslint-disable-next-line
        if (!confirm(HumanInfoMessages.DO_DESTROY.replace('%s', this.condition.name))) {
          return
        }

        this.$store.commit('common/lockGlobal')
        try {
          await this.$store.dispatch('aggJobSearchCondition/destroy', { id: this.id })
          this.$store.dispatch('common/pushToastInfo', { info: HumanInfoMessages.SEARCH_CONDITION_DESTROYED })
        } catch (e) {
          this.$store.dispatch('common/pushToastError', { error: e })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
    filters: {
      normalize (v) {
        if (Array.isArray(v)) {
          if (v.length) {
            return v.length > 20
              ? `${v.slice(0, 20).join(splitter)} 他`
              : v.join(splitter)
          }
          return placeHolder
        }

        return v || placeHolder
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/AggJobSearchCondition.vue